import { render, staticRenderFns } from "./DealerSelectStandalone.vue?vue&type=template&id=5ebc1808&"
import script from "./DealerSelectStandalone.vue?vue&type=script&lang=js&"
export * from "./DealerSelectStandalone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports